
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-issue-seller-other-state-pincodewise-statement',
  templateUrl: './issue-seller-other-state-pincodewise-statement.component.html',
  styleUrl: './issue-seller-other-state-pincodewise-statement.component.scss'
})


export class IssueSellerOtherStatePincodewiseStatementComponent implements OnInit {
  mumbaipincodewisedata;
  thanepincodewisedata;
  jilhapincodewisedata;
  otherstatepincodewisedata;
  total_pin_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  total_mumbai_pin_sub_count = 0;
  totalmumbaiparcel = 0;
  totalmumbaianksankhya = 0;
  total_thane_pin_sub_count = 0;
  totalthaneparcel = 0;
  totalthaneanksankhya = 0;
  total_dist_pin_sub_count = 0;
  totaldistparcel = 0;
  totaldistanksankhya = 0;
  filteredotherstatepincodewisedata = [];
  pincodewisesubcoutprinting = [];
  sundayankDate;
  dispatchankDate;

  constructor(
    private dialogref: MatDialogRef<IssueSellerOtherStatePincodewiseStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  updateStatus: any
  issuedate: any
  state: any
  district: any
  deleveryMode: any
  ngOnInit(): void {
    this.mumbaipincodewisedata = this.data['data'].filter(
      (a) => a['state'] === 'महाराष्ट्र' && a['district'] === 'मुंबई'
    );
    this.thanepincodewisedata = this.data['data'].filter(
      (a) => a['state'] === 'महाराष्ट्र' && a['district'].trim() === 'ठाणे'
    );
    let data = this.data['data']
      .filter((a) => a['state'] === 'महाराष्ट्र')
      .filter((a) => a['district'] !== 'मुंबई');
    this.jilhapincodewisedata = data.filter(
      (a) => a['district'].trim() !== 'ठाणे'
    );
    this.otherstatepincodewisedata = this.data['data'].filter(
      (a) => a['state'] !== 'महाराष्ट्र'
    );
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issuedate']
    this.state = this.data.state;
    this.district = this.data.district;
    this.deleveryMode = this.data['deleveryMode']
    // console.log('mumbaipincodewisedata', this.mumbaipincodewisedata);
    // console.log('thanepincodewisedata', this.thanepincodewisedata);
    // console.log('jilhapincodewisedata', this.jilhapincodewisedata);
    // console.log('otherstatepincodewisedata', this.otherstatepincodewisedata);
    if (this.issuedate == undefined) {
      alert("Please Select Issue Date !!");
    }
    if (this.dispatchankDate == undefined) {
      alert("Please Select Dispatch Date!!");
    }
    if (this.updateStatus) {
      this.getOtherStatePincodewiseStatement();
      this.getMumbaiPincodeStatement();
      this.getThanePincodeStatement();
      this.getDistrictwiseStatement();
    } else {
      this.getOtherStatePincodewiseStatementList();
    }

  }

  getDistrictwiseStatement() {
    this.total_dist_pin_sub_count = 0;
    this.totaldistparcel = 0;
    this.totaldistanksankhya = 0;
    let tempdata = this.uniqueid(
      this.jilhapincodewisedata,
      (a) => a['district']
    );

    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.jilhapincodewisedata.filter(
        (a) => a['district'] == tempdata[index]['district']
      );

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );

        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );

          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
          }
        }
      }

      this.total_dist_pin_sub_count += totalTapalCount;
      this.totaldistparcel += parcelval;
      this.totaldistanksankhya += anksankhya;
    }
  }

  getThanePincodeStatement() {
    this.total_thane_pin_sub_count = 0;
    this.totalthaneparcel = 0;
    this.totalthaneanksankhya = 0;
    let tempdata = this.uniqueid(
      this.thanepincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.thanepincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
            // console.log({ anksankhya });
          }
        }
      }
      this.total_thane_pin_sub_count += totalTapalCount;
      this.totalthaneparcel += parcelval;
      this.totalthaneanksankhya += anksankhya;
    }
  }

  getMumbaiPincodeStatement() {
    this.total_mumbai_pin_sub_count = 0;
    this.totalmumbaiparcel = 0;
    this.totalmumbaianksankhya = 0;
    let tempdata = this.uniqueid(
      this.mumbaipincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.mumbaipincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
            // console.log({ anksankhya });
          }
        }
      }
      this.total_mumbai_pin_sub_count += totalTapalCount;
      this.totalmumbaiparcel += parcelval;
      this.totalmumbaianksankhya += anksankhya;
    }
  }

  getOtherStatePincodewiseStatement() {
    this.subTotal1 = 0
    this.subTotal2 = 0
    this.countBundleTotal1 = 0
    this.countBooksBundleTotal1 = 0
    this.countBundleTotal2 = 0
    this.countBooksBundleTotal2 = 0
    this.total_pin_sub_count = 0;
    this.totalparcel = 0;
    this.totalanksankhya = 0;
    let tempdata = this.uniqueid(
      this.otherstatepincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    this.filteredotherstatepincodewisedata = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.otherstatepincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
            // console.log({ anksankhya });
          }
        }
      }
      // console.log({ totalTapalCount });
      // console.log('*********Ended***********');

      this.filteredotherstatepincodewisedata.push({
        name: tempdata[index]['name'],
        Subscription_Type: tempdata[index]['Subscription_Type'],
        address: tempdata[index]['address'],
        country: tempdata[index]['country'],
        delivery_mode: tempdata[index]['delivery_mode'],
        district: tempdata[index]['district'],
        pincode: tempdata[index]['pincode'],
        state: tempdata[index]['state'],
        sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
        taluka: tempdata[index]['taluka'],
        sub: totalTapalCount,
        parcel: `${parcelval}=${anksankhya}`,
      });

      this.total_pin_sub_count += totalTapalCount;
      this.totalparcel += parcelval;
      this.totalanksankhya += anksankhya;

    }
    // console.log(
    //   'filteredotherstatepincodewisedata',
    // );
    this.filteredotherstatepincodewisedata.sort((a, b) => {
      return a.state.localeCompare(b.state);
    });

    let totalcount = Object.keys(this.filteredotherstatepincodewisedata).length;
    let tempcount = Math.ceil(totalcount / 2);
    let val = 0;
    let a = 0;
    let c = 0;
    for (let i = 0; i < tempcount; i++) {
      val += 2;
      this.pincodewisesubcoutprinting.push({
        state1: '',
        pincode1: 0,
        sub1: 0,
        parcel1: 0,
        state2: '',
        pincode2: 0,
        sub2: 0,
        parcel2: 0,
      });
    }

    let b = Math.ceil(val / 2);
    for (
      let index = 0;
      index < Object.keys(this.filteredotherstatepincodewisedata).length;
      index++
    ) {
      if (index < val) {
        // console.log('val works');
        if (index == a) {
          // console.log('a works', a, index);
          this.pincodewisesubcoutprinting[a]['state1'] =
            this.filteredotherstatepincodewisedata[index]['state'];
          this.pincodewisesubcoutprinting[a]['pincode1'] =
            this.filteredotherstatepincodewisedata[index]['pincode'];
          this.pincodewisesubcoutprinting[a]['sub1'] =
            this.filteredotherstatepincodewisedata[index]['sub'];
          this.pincodewisesubcoutprinting[a]['parcel1'] =
            this.filteredotherstatepincodewisedata[index]['parcel'];
          if (a != tempcount - 1) {
            a += 1;
          }
          this.subTotal1 += Number(this.filteredotherstatepincodewisedata[index]['sub'])
          this.countBundleTotal1 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[0] : "")
          this.countBooksBundleTotal1 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[1] : "")
        } else if (index == b) {
          // console.log('b works', b, c, index);
          this.pincodewisesubcoutprinting[c]['state2'] =
            this.filteredotherstatepincodewisedata[index]['state'];
          this.pincodewisesubcoutprinting[c]['pincode2'] =
            this.filteredotherstatepincodewisedata[index]['pincode'];
          this.pincodewisesubcoutprinting[c]['sub2'] =
            this.filteredotherstatepincodewisedata[index]['sub'];
          this.pincodewisesubcoutprinting[c]['parcel2'] =
            this.filteredotherstatepincodewisedata[index]['parcel'];
          c += 1;
          b += 1;
          this.subTotal2 += Number(this.filteredotherstatepincodewisedata[index]['sub'])
          this.countBundleTotal2 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[0] : "")
          this.countBooksBundleTotal2 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[1] : "")

        }


      }
    }

    // console.log('pincodewisesubcoutprinting', this.pincodewisesubcoutprinting);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  saveSubscriptionPincodeStatewiseEntry() {
    console.log(this.pincodewisesubcoutprinting);
    const filteredData = this.pincodewisesubcoutprinting.map((item) => ({
      issue_date: this.issuedate,
      country: "भारत",
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: this.deleveryMode[0],
      dispatch_date: this.convertDateFormat(this.dispatchankDate),

      state1: item.state1,
      pincode1: item.pincode1,
      no_of_book_bundle1: item.parcel1 != undefined && item.parcel1 != null && item.parcel12 != 0 && item.parcel1 != "" ? item.parcel1.split("=")[1] : "",
      count_bundle1: item.parcel1 != undefined && item.parcel1 != null && item.parcel1 != 0 && item.parcel1 != "" ? item.parcel1.split("=")[0] : "",
      no_subscriber1: item.sub1,

      state2: item.state2,
      pincode2: item.pincode2,
      no_of_book_bundle2: item.parcel2 != undefined && item.parcel2 != null && item.parcel2 != 0 && item.parcel2 != "" ? item.parcel2.split("=")[1] : "",
      count_bundle2: item.parcel2 != undefined && item.parcel2 != null && item.parcel2 != 0 && item.parcel2 != "" ? item.parcel2.split("=")[0] : "",
      no_subscriber2: item.sub2,

      otherStateTotal: this.total_pin_sub_count,
      otherStateGatthe: this.totalparcel,
      otherStatesankhya: this.totalanksankhya,

      mumbaiPincodeWiseTotal: this.total_mumbai_pin_sub_count,
      mumbaiGatthe: this.totalmumbaiparcel,
      mumbaisankhya: this.totalmumbaianksankhya,

      thanePincodeWiseTotal: this.total_thane_pin_sub_count,
      thaneGatthe: this.totalthaneparcel,
      thanesankhya: this.totalthaneanksankhya,

      districtWiseTotal: this.total_dist_pin_sub_count,
      districtWiseGatthe: this.totaldistparcel,
      districtWisesankhya: this.totaldistanksankhya,

      allAdditionTotal: Number(this.total_pin_sub_count)+Number(this.total_mumbai_pin_sub_count)+Number(this.total_thane_pin_sub_count) +  Number(this.total_dist_pin_sub_count),
      allAdditionGatthe: Number(this.totalparcel)+Number(this.totalmumbaiparcel)+Number(this.totalthaneparcel)+Number(this.totaldistparcel),
      allAdditionsankhya: Number(this.totalanksankhya)+Number(this.totalmumbaianksankhya)+Number(this.totalthaneanksankhya)+Number(this.totaldistanksankhya),

    }));
    console.log(filteredData);
    this.service.saveIssueSellerPincodeStatewiseStatement(filteredData).subscribe((data) => {
      alert('Pincodewise Statements Save Successfully!');
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormat1(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }

  deletePincodewiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteIssueSellerOtherPincodewiseStatement(request).subscribe((data: any) => {

      alert(data.message);
      this.getOtherStatePincodewiseStatementList();
    });
  }


  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.pincodewisesubcoutprinting.forEach(item => item.selected = this.checkAll);

    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.pincodewisesubcoutprinting.every(item => item.selected);
    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }
  subTotal1: any = 0
  subTotal2: any = 0
  countBundleTotal1: any = 0
  countBooksBundleTotal1: any = 0
  countBundleTotal2: any = 0
  countBooksBundleTotal2: any = 0
  getOtherStatePincodewiseStatementList() {
    this.pincodewisesubcoutprinting = []
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
    }
    this.service.getIssueSellerOtherStatePincodewiseStatementList(request).subscribe((data: any) => {
      this.pincodewisesubcoutprinting = data;

      //parprant 
      this.total_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].prantwise_total3),
        this.totalparcel = Number(this.pincodewisesubcoutprinting[0].PRANTWISE_BUNDLE_COUNT),
        this.totalanksankhya = Number(this.pincodewisesubcoutprinting[0].PRANTWISE_BOOKS_BUNDLE_COUNT),


        ///Mumbai Total
        this.total_mumbai_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].mumbai_total),
        this.totalmumbaiparcel = Number(this.pincodewisesubcoutprinting[0].MUMBAI_BUNDLE_COUNT),
        this.totalmumbaianksankhya = Number(this.pincodewisesubcoutprinting[0].MUMBAI_BOOKS_BUNDLE_COUNT),

        ///Thane Total
        this.total_thane_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].thane_total),
        this.totalthaneparcel = Number(this.pincodewisesubcoutprinting[0].THANE_BUNDLE_COUNT),
        this.totalthaneanksankhya = Number(this.pincodewisesubcoutprinting[0].THANE_BOOKS_BUNDLE_COUNT),

        /// District wise total
        this.total_dist_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].without_mumbai_thane_total),
        this.totaldistparcel = Number(this.pincodewisesubcoutprinting[0].WITHOUT_MUMBAI_THANE_BUNDLE_COUNT),
        this.totaldistanksankhya = Number(this.pincodewisesubcoutprinting[0].WITHOUT_MUMBAI_THANE_BOOKS_BUNDLE_COUNT),



        ////total calculated
        this.subTotal1 = Number(this.pincodewisesubcoutprinting[0].prantwise_total1)
      this.subTotal2 = Number(this.pincodewisesubcoutprinting[0].prantwise_total2)

      this.countBundleTotal1 = Number(this.pincodewisesubcoutprinting[0].count_bundle_total1)
      this.countBooksBundleTotal1 = Number(this.pincodewisesubcoutprinting[0].count_books_bundle_total1)
      this.countBundleTotal2 = Number(this.pincodewisesubcoutprinting[0].count_bundle_total2)
      this.countBooksBundleTotal2 = Number(this.pincodewisesubcoutprinting[0].count_books_bundle_total2)
    });
  }


}
